export interface CountBadgeProps {
  /** Number to show ("99+" above `max`). Hidden when 0 or absent (unless `dot`). */
  count?: number | undefined
  max?: number
  /** Only a marker (news without a number). */
  dot?: boolean
  /** danger = pending/alert (default) · brand = informative. */
  tone?: 'danger' | 'brand'
  className?: string
}

/**
 * Small counter in the corner of an IconButton, Sidebar/BottomNav item or menu item.
 * Decorative for screen readers: the parent carries the count in its accessible name
 * (e.g. "Notificações, 3 novas").
 */
export function CountBadge({
  count,
  max = 99,
  dot = false,
  tone = 'danger',
  className,
}: CountBadgeProps) {
  if (!dot && !count) return null
  const classes = [
    'ui-count-badge',
    `ui-count-badge--${tone}`,
    dot ? 'ui-count-badge--dot' : '',
    className,
  ]
  return (
    <span className={classes.filter(Boolean).join(' ')} aria-hidden="true">
      {dot ? null : count !== undefined && count > max ? `${max}+` : count}
    </span>
  )
}
